(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fresh-feast-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const timers = document.querySelectorAll('[data-ff-countdown-time]');
    if (!timers.length) return;

    const argentinaClock = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'America/Argentina/Buenos_Aires',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });

    const renderCountdown = () => {
      const parts = Object.fromEntries(
        argentinaClock
          .formatToParts(new Date())
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );
      const currentSeconds = (parts.hour * 3600) + (parts.minute * 60) + parts.second;
      let remaining = (3 * 3600) - currentSeconds;
      if (remaining <= 0) remaining += 24 * 3600;

      const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      const value = `${hours}:${minutes}:${seconds}`;

      timers.forEach((timer) => {
        timer.textContent = value;
      });
    };

    renderCountdown();
    window.setInterval(renderCountdown, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
